// tslint:disable
export var LocationPurposeType;
(function (LocationPurposeType) {
    // UNKN
    LocationPurposeType[LocationPurposeType["UNKN"] = 0] = "UNKN";
    // HDQTR
    LocationPurposeType[LocationPurposeType["HDQTR"] = 1] = "HDQTR";
    // SALE
    LocationPurposeType[LocationPurposeType["SALE"] = 2] = "SALE";
    // HOME
    LocationPurposeType[LocationPurposeType["HOME"] = 3] = "HOME";
    // WORK
    LocationPurposeType[LocationPurposeType["WORK"] = 4] = "WORK";
    // SEAS
    LocationPurposeType[LocationPurposeType["SEAS"] = 5] = "SEAS";
    // MAIL
    LocationPurposeType[LocationPurposeType["MAIL"] = 6] = "MAIL";
    // BILL
    LocationPurposeType[LocationPurposeType["BILL"] = 7] = "BILL";
    // SHIP
    LocationPurposeType[LocationPurposeType["SHIP"] = 8] = "SHIP";
})(LocationPurposeType || (LocationPurposeType = {}));
//# sourceMappingURL=LocationPurposeType.js.map